<template>
  <div class="modal" :class="{ 'is-active': isOpen }">
    <div class="modal-background" @click="close"></div>
    <div class="modal-card" :class="{ big: isBig, medium: isMedium }">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ title }}</p>
        <button class="delete" aria-label="close" @click="close"></button>
      </header>
      <section class="modal-card-body"><slot /></section>
      <footer class="modal-card-foot buttons is-right">
        <slot name="footer" />
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  name: "modal-clossable",
  props: ["title", "isOpen", "isBig", "isMedium"],
  created() {
    document.addEventListener("keydown", this.escapeKeyListener)
  },
  destroyed() {
    document.removeEventListener("keydown", this.escapeKeyListener)
  },
  methods: {
    close() {
      this.$emit("close")
    },
    escapeKeyListener(e) {
      if (this.isOpen && e.keyCode === 27) {
        this.close()
      }
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/style.scss";
.modal-card-title {
  flex-shrink: 1;
}
.modal {
  flex-direction: column;
}
.modal-card {
  padding-left: 1em;
  padding-right: 1em;
}
.big {
  width: 100%;
}
.medium {
  width: 100%;
  max-width: 960px;
}
</style>
